import { render } from "./Description.vue?vue&type=template&id=7f2ba4e1&scoped=true"
const script = {}

import "./Description.vue?vue&type=style&index=0&id=7f2ba4e1&scoped=true&lang=css"

import exportComponent from "I:\\JavaWork\\Recruit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2ba4e1"]])

export default __exports__